module.exports = __webpack_public_path__ + "static/media/creativity2.a30ea8c5.gif";